import * as React from "react";
import styled from "styled-components";
import TimeIcon from "@material-ui/icons/Timelapse";
import { Button } from "@material-ui/core";
import { reprocess } from "../../../../sdk/release";

interface ReleaseDetailReprocess {
  releaseId: string;
  onReleaseReprocessed: () => Promise<void>;
}

export const ReleaseDetailReprocess: React.FC<ReleaseDetailReprocess> = ({
  releaseId,
  onReleaseReprocessed,
}) => {
  const [reprocessing, setReprocessing] = React.useState(false);

  const handleReprocess = async () => {
    if (releaseId) {
      setReprocessing(true);
      await reprocess(releaseId);
      await onReleaseReprocessed();
      setReprocessing(false);
    }
  };

  return (
    <React.Fragment>
      <PendingIcon />
      <ErrorMessage>Validating release...</ErrorMessage>
      <ErrorCaption>Please come back later</ErrorCaption>
      <Button variant="contained" color="default" onClick={handleReprocess}>
        {reprocessing ? <TimeIcon /> : "Re-process..."}
      </Button>
    </React.Fragment>
  );
};

const ErrorMessage = styled.h2``;

const PendingIcon = styled(TimeIcon)`
  width: 2em;
  height: 2em;
`;

const ErrorCaption = styled.p``;
